import { render, staticRenderFns } from "./AmountTableRow.vue?vue&type=template&id=1fd2b05f&lang=pug"
import script from "./AmountTableRow.vue?vue&type=script&lang=js"
export * from "./AmountTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports